import { Text, View } from '@/styles/reactnative';
import { CButton } from '@app/components/Common';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DerivativesHeaderSection, DerivativesHeaderWrapper } from './styles';

import { ThemeContext } from '@/theme/ThemeProvider';
import { COLORS } from '@app/constants';
import { useTradeModalStore } from '@app/hooks/trade/modalStore';
import { IconChevronDown } from '@tabler/icons-react';
import { useTradeSetting } from '../../../../../hooks/trade/tradeSetting';
import useTradeStore from '../../../../../hooks/trade/tradeStore';
import { useTradePosition } from '../../../../../hooks/trade/tradePosition';

const DerivativesHeader = () => {
  const { textw } = React.useContext(ThemeContext).theme.COLORS;
  const { theme } = useContext(ThemeContext);

  const { t } = useTranslation();

  const { data: tradeStore } = useTradeStore();
  const { data: tradeSetting } = useTradeSetting(tradeStore?.ep_id);
  const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore();
  const { data: positions } = useTradePosition();

  // 현재 종목의 포지션이 있으면 해당 포지션의 설정 사용
  const currentPosition = useMemo(() =>
    positions?.find((pos: any) => +pos.exchange_pairs_id === +tradeStore?.ep_id),
    [positions, tradeStore?.ep_id]
  );

  const displayCrossIso = currentPosition?.cross_iso ?? tradeSetting?.cross_iso;
  const displayLeverage = currentPosition?.leverage ?? tradeSetting?.leverage;

  return (
    <DerivativesHeaderWrapper>
      <DerivativesHeaderSection>
        <View
          style={{
            border: `1px solid ${theme.COLORS.PrimaryBorder}`,
            width: 130,
            backgroundColor: theme.COLORS.PrimaryInputBg,
            cursor: 'pointer',
          }}
          onClick={() => {
            mutateModalStore({
              ...modalStore,
              crossModal: true,
            });
          }}
        >
          <Text size={14} style={{ letterSpacing: 1.1, flex: 1, minWidth: 40 }}>
            {t(displayCrossIso === 'C' ? 'cross' : 'iso')}
          </Text>
        </View>

        <CButton
          title={`${displayLeverage}x`}
          onClick={() => {
            mutateModalStore({
              ...modalStore,
              crossModal: true,
            });
          }}
          iconLeft={false}
          lefticon={<div></div>}
          icon={<IconChevronDown size={18} color={textw} />}
          style={{
            width: 176,
            fontSize: 16,
            justifyContent: 'space-between',
            fontWeight: '600',
            color: COLORS.primary,
            letterSpacing: 1.3,
            height: 30,
            borderRadius: 0,
            backgroundColor: theme.COLORS.ButtonBg,
            border: `1px solid ${theme.COLORS.ButtonBorder}`,
            cursor: 'pointer',
          }}
        />
      </DerivativesHeaderSection>
    </DerivativesHeaderWrapper>
  );
};

export default DerivativesHeader;
